'use client';

import {
  OfferCardProps,
  OfferReviewDialog,
  PurchaseButton,
} from '@wwe-portal/ui/features/offer';
import { SubscriptionTier } from '@wwe-portal/entities/subscription.type';
import React, { useState } from 'react';
import { parseOfferPreview } from '@wwe-portal/web/components/club-store/modals/OfferPreviewDialog';
import {
  cardStatusLabel,
  getCardStatus,
  parseRegionalOfferPrice,
} from '@wwe-portal/web/utils/offer/mapper';
import { OfferData } from '@wwe-portal/entities/offer.type';

export interface UseExclusiveDialogProps {
  isLoading: boolean;
  handleBuy: (data: {
    offerData: OfferData | OfferCardProps;
    tier: SubscriptionTier;
  }) => void;
}

export const useExclusiveDialogRevamp = ({
  isLoading,
  handleBuy,
}: {
  isLoading: boolean;
  handleBuy: (data: {
    offerData: OfferData | OfferCardProps;
    tier: SubscriptionTier | undefined;
  }) => void;
}) => {
  const [data, setData] = useState<
    | {
        offerData: OfferData;
        tier?: SubscriptionTier;
        isBlocked?: boolean;
        endDate?: Date;
      }
    | undefined
  >();

  const getActionBtn = (
    offer: OfferData,
    tier?: SubscriptionTier,
    isBlocked?: boolean
  ) => {
    const { isComingSoon, isNotReady } = getCardStatus(offer);
    const statusLabel = cardStatusLabel({
      isComingSoon,
      isNotReady,
    });
    return (
      <PurchaseButton
        isBlocked={isBlocked}
        onClick={() => {
          if (!offer.StockQuantity) {
            return;
          }
          handleBuy({
            offerData: offer,
            tier: tier,
          });
        }}
        loading={isLoading}
        className="w-full"
        disabled={isComingSoon || isNotReady}
        price={statusLabel ?? parseRegionalOfferPrice(offer).price}
      />
    );
  };

  const exclusiveDialog = data ? (
    <OfferReviewDialog
      data={parseOfferPreview(
        data.offerData,
        getActionBtn(data.offerData, data.tier, data.isBlocked)
      )}
      open
      onClose={() => setData(undefined)}
    />
  ) : null;

  return {
    exclusiveDialog,
    setExclusiveDialogData: setData,
    closeDialog: () => setData(undefined),
  };
};
